<template>
  <div class="w-full lg:w-1/3 h-full flex flex-col">
    <h2 class="hidden lg:block px-4 py-2 rounded" :class="defaultColorClass">
      <span class="text-xl font-bold">En amont : {{ store.home.todo.total }}</span>
    </h2>
    <ul class="bg-grey-850 p-1 rounded lg:mt-1 flex flex-col gap-1 overflow-y-scroll">
      <li v-for="letterFile in letterFiles" :key="letterFile.id">
        <LetterFile :letter-file="letterFile" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import LetterFile from "../../components/LetterFile.vue";
import { computed } from "vue";
import { useLetterFileStore } from "../../stores/letter-file.store";
import { useLetterFileColor } from "../../composable/useLetterFileColor";

const store = useLetterFileStore();
const letterFiles = computed(() => store.home.todo.data);

const { defaultColorClass } = useLetterFileColor();
</script>
